import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Skeleton from 'react-loading-skeleton'
import Button from '../../../../components/Button'

import { adsWasLoadedSelector, adsSelector } from '../../../../modules/selectors/ads'
import { campaignGraphsSelector, campaignGraphsWasLoadedSelector } from '../../../../modules/selectors/campaignsSummary'

import useSummaryPagesStyle from '../../../../styles/common/summaryPages'
import useStyles from './styles'

const PageWelcomeHeading = ({
  isPageDataLoading,
  campaignName = '',
  scrollToAdsSectionHandler,
  scrollToReportsSectionHandler,
  showButtons = true
}) => {
  const summaryPagesClasses = useSummaryPagesStyle()
  const classes = useStyles()

  const { t } = useTranslation()

  const ads = useSelector(adsSelector)
  const adsWasLoaded = useSelector(adsWasLoadedSelector)
  const graphs = useSelector(campaignGraphsSelector)
  const graphsWasLoaded = useSelector(campaignGraphsWasLoadedSelector)

  const showAdsButton = adsWasLoaded && !!ads.length
  const showGraphsButton = graphsWasLoaded && !!graphs.data?.length

  return (
    <>
      <h2 className={summaryPagesClasses.welcomeMessage}>
        {isPageDataLoading ? (
          <Skeleton className={classes.welcomeMessageSkeleton} />
        ) : (
          t(`Welcome to the campaign summary ${campaignName && `for ‘${campaignName}’`}`)
        )}
      </h2>
      {showButtons && (
        <div className={summaryPagesClasses.welcomeButtonsWrapper}>
          {isPageDataLoading ? (
            <>
              <Skeleton height={17} width={160} />
              <Skeleton height={17} width={185} />
            </>
          ) : (
            <>
              {showAdsButton && <Button onClick={scrollToAdsSectionHandler}>{t('View ad performance')}</Button>}
              {showGraphsButton && (
                <Button onClick={scrollToReportsSectionHandler}>{t('View performance report')}</Button>
              )}
            </>
          )}
        </div>
      )}
    </>
  )
}

export default PageWelcomeHeading
